export default {
  async actionEnsureCurrencySetting({ dispatch, getters }, params) {
    if (!getters.hasCurrencySetting) {
      return dispatch('actionGetCurrencySetting', params);
    }
    return getters.currencySetting;
  },
  async actionGetCurrencySetting({ commit }, params) {
    const { data: { results: [{ currency } = {}] = [] } } = await this.$services._core.featureSettings().getAllFeatureSettings(params);
    commit('SET_CURRENCY_SETTING', currency);
    return currency;
  }
};
